<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger':
          current.errors[propname] && current.errors[propname].length > 0,
      }"
      >{{ label }}</label
    >
      <select
        class="form-control"
        autofocus="autofocus"
        v-model="current[propname]"
      >
        <option
          v-for="(c, key) in cuentas_contables"
          :value="c.id"
          :key="key"
          >{{ c.nombre }}</option
        >
      </select>
    <small
      v-if="current.errors && current.errors[propname]"
      class="form-text text-danger"
      >{{ current.errors[propname][0] }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    current: {
      type: Object,
    },
    propname: {
      type: String,
      default: 'cuenta_contable'
    },
    label: {
      type: String,
      default: 'Cuenta Contable'
    },
  },
  computed: {
    ...mapGetters({
      cuentas_contables: "conta/cuentas_contables",
    }),
  },
  mounted() {
    this.$store.dispatch("conta/cuentas_contables", {
      activo: true,
      listado_simple: true,
    });
  },
  methods: {
    onChangeCuentaContable(event) {
      this.$emit("onChangeCuentaContable", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("conta/cuentas_contables", {
        page: 1,
        activo: true,
        listado_simple: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>
